import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "../api";
import "./ResetPassword.css";

export default function ResetPassword() {
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    email: "",
    tempPassword: "",
    newPassword: "",
    confirmPassword: ""
  });

  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState({ type: "", message: "" });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // 1. Check if temp data exists
    const savedEmail = localStorage.getItem("auth_tempEmail");
    const savedTemp = localStorage.getItem("auth_tempPassword");

    if (!savedEmail || !savedTemp) {
      // If data missing, redirect back to forgot page
      alert("Session expired. Please start reset again.");
      navigate("/forgot-password");
      return;
    }

    // 2. Auto-fill local state
    setFormData((prev) => ({
      ...prev,
      email: savedEmail,
      tempPassword: savedTemp
    }));
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: null });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});
    setIsLoading(true);

    // Simple validation
    if (formData.newPassword !== formData.confirmPassword) {
      setErrors({ confirmPassword: "Passwords do not match" });
      setIsLoading(false);
      return;
    }

    try {
      await api.post("/api/auth/change-temp-to-new", formData);
      
      setStatus({ type: "success", message: "Password Updated Successfully!" });
      
      // Clear Auth Tokens after successful reset
      localStorage.removeItem("auth_tempEmail");
      localStorage.removeItem("auth_tempPassword");
      
      setTimeout(() => {
        navigate("/login");
      }, 2000);

    } catch (err) {
      const msg = err.response?.data?.message || "Failed to update password";
      setStatus({ type: "error", message: msg });
    } finally {
      setIsLoading(false);
    }
  };

  // Styles inlined for simplicity, or use external CSS file
  return (
    <div className="rp-container">
      <div className="rp-card">
        <h2>Set New Password</h2>
        <p className="rp-subtitle">Verify identity using temporary password.</p>
        
        <form onSubmit={handleSubmit} className="rp-form">
          
          {/* Locked Email Input */}
          <div className="rp-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              readOnly
              className="rp-input rp-readonly"
            />
          </div>

          {/* Locked Temp PW Input */}
          <div className="rp-group">
            <label>Temporary Password</label>
            <input
              type="text"
              name="tempPassword"
              value={formData.tempPassword}
              readOnly
              className="rp-input rp-readonly"
              title="Copied automatically from verification"
            />
          </div>

          {/* New Password */}
          <div className="rp-group">
            <label>New Password</label>
            <input
              type="password"
              name="newPassword"
              value={formData.newPassword}
              onChange={handleChange}
              placeholder="Min 6 Characters"
              className="rp-input"
            />
            {errors.newPassword && <span className="rp-error">{errors.newPassword}</span>}
          </div>

          {/* Confirm Password */}
          <div className="rp-group">
            <label>Confirm New Password</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              className="rp-input"
            />
            {errors.confirmPassword && <span className="rp-error">{errors.confirmPassword}</span>}
          </div>

          <button type="submit" disabled={isLoading} className={`rp-btn ${isLoading ? 'rp-loading' : ''}`}>
            {isLoading ? "Updating..." : "Complete Password Reset"}
          </button>

          {status.message && (
            <div className={`rp-alert ${status.type}`}>{status.message}</div>
          )}
        </form>

        
      </div>
    </div>
  );
}